import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DceRegistryService } from '../services/dce-registry.service';

export const loadDceGuard: CanActivateFn = async (route) => {
  const dceRegistry = inject(DceRegistryService);
  const bundleUrl = route.data['bundleUrl'] as string | undefined;

  if (!bundleUrl) {
    // Do not block route activation; host component will surface configuration errors.
    return true;
  }

  try {
    await dceRegistry.loadBundle(bundleUrl);
    return true;
  } catch {
    // Keep navigation working even when the bundle is temporarily unavailable.
    return true;
  }
};
